<form [formGroup]="skjema" (ngSubmit)="lagre()" novalidate>
  <mat-toolbar color="primary">
    <span>{{ "Rediger {navn}" | translate: {navn: skjema.value.navn} }}</span>
    <button mat-icon-button mat-dialog-close aria-label="Lukk dialog">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
    </button>
  </mat-toolbar>

  <mat-dialog-content #skjemaKontainer>
    <aksjeeier-rediger [skjema]="skjema"/>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{'Scroll ned for å se resten av skjemaet...' | translate}}</span></div>
    <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()">{{ "Lagre" | translate }}</button>
  </mat-dialog-actions>

</form>
